export const environment = {
    production: false,
    url: "https://api-test.grupodaytona.com",
    // url: "https://charming-hoover.162-255-87-55.plesk.page",
    apiCloud: {
        appPublic: "GDP_22ceaa886dcg04f1b944e255g5c5b8",
        appSecret: "GDS_eeg5caf27gddbc55a8gb85cf63943e"
    },
    useMinio: true  // TODO: cambiar a true cuando MINIO esté en producción
};
